import React, { useEffect, useState } from "react";

import RouteSection from "../RouteSection/RouteSection";
import { SelfSection } from "../SelfSection/SelfSection";

export function DesktopToolbar(props) {
  const [customRenderSection, setCustomRenderSection] = useState(props.customRenderSection);
  const [profile, setProfile] = useState(props.profile);
  const [routeSection, setRouteSection] = useState(props.routeSection);
  const [selfSection, setSelfSection] = useState(props.selfSection);

  const renderCustomRenderSection = customRenderSection
    ? customRenderSection.map((section, index) => {
        if (section.isComponent) {
          return (
            <section.render
              key={`section-${index}`}
              totalUnreadMessages={props.totalUnreadMessages}
              {...section.componentProps}
            />
          );
        } else {
          return section.render;
        }
      })
    : [];

  if (selfSection) {
    selfSection["profile"] = profile;
    selfSection["baseRoute"] = props.baseRoute;
  }

  useEffect(() => {
    setCustomRenderSection(props.customRenderSection);
    setRouteSection(props.routeSection);
    setSelfSection(props.selfSection);
    setProfile(props.profile);
  }, [props.customRenderSection, props.routeSection, props.selfSection, props.profile]);

  return (
    <nav className="Toolbar__nav-desktop d-flex align-items-center tw:justify-center">
      <div className="Toolbar__nav-desktop-container d-flex align-items-center">
        {routeSection && (
          <RouteSection
            config={routeSection}
            handleClickSearch={props.handleClickSearch}
            totalUnreadMessages={props.totalUnreadMessages}
          />
        )}

        {renderCustomRenderSection}
        {selfSection && <SelfSection config={selfSection}></SelfSection>}
      </div>
    </nav>
  );
}
